/* eslint-disable no-undef */
import ReactDOM from 'react-dom/client';
import React from 'react';
import VideoPlayer from '../core/VideoPlayer';
import { logDebugging } from '../log/logger';
import loadPlayListDataModel from '../services/playlists/loadPlayListDataModel';
import * as STATES from '../core/states/player.states';
import * as VOLUME_STATES from '../core/states/volume.states';
import StyleTemplate from '../components/templates/styleTemplate';
import ErrorPage from '../components/errors/errorPage';
import ServiceError from '../core/errors/ServiceError';
import PlayerEvent from '../core/events/player.event';
import * as AdEvents from '../core/events/ad.events';
import TrackerManager from './TrackerManager';
import { activateClickToShowControls } from '../utils/showControls';
import { toggleModalVisibility } from '../components/modal/helpers';
// import TrackerRequestPublisher from './TrackerRequestPublisher';

export default class TpxPlayer {
  constructor(config) {
    this.config = config;
    this.trackerManager = new TrackerManager(this.config);
    // this.trackerRequestPublisher = new TrackerRequestPublisher(this.config);
    this.tpxPlayerEvent = new PlayerEvent('onTpxPlayerEvent');
    this.isRootUnmount = false;
    // eslint-disable-next-line no-undef
    this.rootCreated = ReactDOM.createRoot(document.getElementById(this.config.targetContentId));
    activateClickToShowControls(config);
  }

  async loadPlayList() {
    try {
      const [playlistmodel, configPlayerModel] = await loadPlayListDataModel(this.config);
      this.playlistDataModel = playlistmodel;
      this.config.player = configPlayerModel.build();
      this.config.showControls = this.playlistDataModel.isVideoProducer()
        ? false
        : this.config.showControls;
      this.config.poc.idCompany = this.playlistDataModel.publisherId;
      this.trackerManager.initTracker(this.playlistDataModel);
      this.loadingTimes = null;
      // this.trackerRequestPublisher.initTracker(this.playlistDataModel);
    } catch (error) {
      throw new ServiceError(error.message, error.code);
    }
  }

  async loadVideoPlayer() {
    if (this.videoPlayer) this.videoPlayer.unsubscribe();
    this.videoPlayer = new VideoPlayer(this.playlistDataModel.getItemSelected(), this.config);
    this.videoPlayer.playerEvent.subscribe((sender, message) => {
      // logDebugging(sender);

      const [eventState, playerState] = message.message;
      // logDebugging('TpxPlayer2 event2', eventState, playerState);
      switch (eventState) {
        case this.videoPlayer.playerEvent.STATE_EVENT:
          /** WORKAROUND TO TRACK LOADING TIMES */
          if (playerState === STATES.LOADING) {
            this.loadingTimes = { start: Date.now() };
          } else if (this.loadingTimes) {
            this.loadingTimes.end = Date.now();
            this.loadingTimes.total = this.loadingTimes.end - this.loadingTimes.start;
            // this.trackerManager.sendLoadingTracker(JSON.stringify(this.loadingTimes));
            logDebugging(`Loading time:`, this.loadingTimes);
            this.loadingTimes = null;
          }

          if (playerState === STATES.PLAYING) {
            this.videoPlayer.setVolume(this.config.volume);
          }

          this.dispatchEvent(message.message);
          break;

        case this.videoPlayer.playerEvent.VOLUME_EVENT:
          this.config.volume = playerState;
          // logDebugging(`volumeState ${this.videoPlayer.volumeState}`);
          this.config.muted = this.videoPlayer.volumeState === VOLUME_STATES.MUTED;
          // logDebugging(this.config);
          break;

        case this.videoPlayer.playerEvent.THROW_MIDROLL:
          // this.trackerRequestPublisher.sendRequestPublisher('mid');
          this.dispatchEvent([this.videoPlayer.playerEvent.THROW_MIDROLL]);
          break;

        case this.videoPlayer.playerEvent.THROW_OVERLAY:
          // this.trackerRequestPublisher.sendRequestPublisher('overlay');
          this.dispatchEvent([this.videoPlayer.playerEvent.THROW_OVERLAY]);
          break;

        case this.videoPlayer.playerEvent.THROW_POSROLL:
          // this.trackerRequestPublisher.sendRequestPublisher('pos');
          this.dispatchEvent([this.videoPlayer.playerEvent.THROW_POSROLL]);
          break;

        case this.videoPlayer.playerEvent.THROW_PREROLL:
          // this.trackerRequestPublisher.sendRequestPublisher('pre');
          this.dispatchEvent([this.videoPlayer.playerEvent.THROW_PREROLL]);
          break;

        case this.videoPlayer.playerEvent.INIT_PREROLL:
          // this.trackerRequestPublisher.sendRequestPublisher('pre');
          this.changeState(STATES.LOADING);
          this.dispatchEvent([this.videoPlayer.playerEvent.INIT_PREROLL]);
          break;

        case AdEvents.AdVideoStart:
          this.trackerManager.resetDataTracker();
          this.trackerManager.sendTrackerByEvent(AdEvents.AdStarted);
          break;

        case AdEvents.AdVideoFirstQuartile:
        case AdEvents.AdVideoMidpoint:
        case AdEvents.AdVideoThirdQuartile:
          this.trackerManager.sendTrackerByEvent(eventState);
          break;

        case AdEvents.AdVideoComplete:
          this.trackerManager.sendTrackerByEvent(AdEvents.AdStopped);
          break;
        default:
          break;
      }
    });

    this.loadVideoTemplate();
  }

  loadNextVideoPlayer() {
    if (this.playlistDataModel.isPlaylist) {
      this.loadVideoPlayer();
    } else if (this.playlistDataModel.isNextItem() || this.config.loop) {
      if (this.playlistDataModel.isVideoProducer()) {
        this.playlistDataModel.looped = true;
      }
      this.loadVideoPlayer();
    }
  }

  replay() {
    if (this.playlistDataModel.goToIndex(0)) {
      this.loadVideoPlayer();
    }
  }

  loadVideoTemplate() {
    logDebugging('loadVideoTemplate');
    if (this.isRootUnmount) return;
    this.rootCreated.render(
      <StyleTemplate
        config={this.config}
        videoPlayer={this.videoPlayer}
        playlistmodel={this.playlistDataModel}
      />,
    );
  }

  removePlayer() {
    if (this.rootCreated) {
      this.rootCreated.unmount();
      this.isRootUnmount = true;
    }
  }

  printError(error) {
    if (this.isRootUnmount) return;
    this.rootCreated.render(
      <>
        {' '}
        <ErrorPage error={error} />
      </>,
    );
  }

  getLinkVideoProducer() {
    const urlLinkVideoProducer = this.playlistDataModel.videoProducerModel.setMarkerSelectedBySec(
      this.videoPlayer.currentTime,
    );

    return urlLinkVideoProducer;
  }

  // eslint-disable-next-line class-methods-use-this
  showOverlay() {
    if (document.getElementById('tpx-display-overlay-container')) {
      document.getElementById('tpx-display-overlay-container').style.visibility = 'visible';
      setTimeout(() => {
        document.getElementById('tpx-overlay-close').style.visibility = 'visible';
      }, 2000);
      const playerComp = document.getElementById(this.config.targetId);
      document.getElementById('tpx-display-overlay-container').style.scale =
        playerComp.clientWidth < 319 ? playerComp.clientWidth / 320 - 0.05 : 1;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  hideOverlay() {
    if (document.getElementById('tpx-display-overlay-container')) {
      document.getElementById('tpx-display-overlay-container').style.visibility = 'hidden';
      document.getElementById('tpx-overlay-close').style.visibility = 'hidden';
    }
  }

  togglePlaylistModal() {
    if (!this.playlistDataModel.isPlaylist) {
      return this.loadNextVideoPlayer();
    }

    this.videoPlayer.changeState(STATES.STANDBY);
    return toggleModalVisibility('tpx-playlist-modal');
  }

  getEvent() {
    return this.tpxPlayerEvent;
  }

  changeState(state) {
    this.videoPlayer.changeState(state);
  }

  dispatchEvent(arg) {
    this.tpxPlayerEvent.fire(this, { message: arg });
  }
}
